import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store'
import { parseQuery } from '@/utils/location'

Vue.use(VueRouter)

const mainRoutes = [
  {
    path: '/',
    name: 'index',
    redirect: {
      name: store.state.mobile ? 'mobileImChat' : 'imChat'
    }
  },
  {
    path: '/imMiddlePage',
    name: 'imMiddlePage',
    component: () => import('@/views/im-chat/pc/im-middle-page.vue')
  },
  {
    path: '/chatWindow',
    name: 'ChatWindow',
    component: () => import('@/views/chatWindow/index.vue')
  },
  {
    path: '/satisfactionSurvey',
    name: 'SatisfactionSurvey',
    component: () => import('@/views/satisfactionSurvey/index.vue')
  },
  {
    path: '*',
    redirect: { name: 'index' }
  }
]

const router = new VueRouter({
  routes: [...mainRoutes, ...routes]
})
router.onReady(route => {
  const originQuery = parseQuery(location.search)
  // 拼接search参数到路由上，方便解析
  if (Object.keys(originQuery).length > 0) {
    router.replace({
      query: { ...originQuery, ...route.query }
    })
  }
})

export default router
